module.exports = __webpack_public_path__ + "img/Single-dependant.b69deae4.svg";